import { Badge } from "../ui/badge";
import { Sparkles, TrendingUp, Globe, Newspaper } from "lucide-react";

export const NewsHero = () => {
  return (
    <div className="group relative -mt-20 w-full overflow-hidden border-b border-white/10 bg-gradient-to-br from-[#0c4a6e] via-[#075985] to-[#0369a1]">
      {/* Decorative Elements */}
      <div className="pointer-events-none absolute right-0 top-0 -mr-40 -mt-40 h-[600px] w-[600px] rounded-full bg-[#66A0CD] opacity-[0.06] blur-[150px]" />
      <div className="pointer-events-none absolute bottom-0 left-0 -mb-20 -ml-20 h-[400px] w-[400px] rounded-full bg-sky-400 opacity-[0.06] blur-[120px]" />

      <div className="container relative z-10 mx-auto grid items-center gap-8 px-4 pb-12 pt-32 md:px-6 md:pb-20 lg:grid-cols-2">
        {/* Left Side: Copy */}
        <div className="space-y-6 delay-100 duration-700 animate-in fade-in slide-in-from-left-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 shadow-inner backdrop-blur-xl">
            <Sparkles className="h-3.5 w-3.5 fill-emerald-400/20 text-emerald-400" />
            <span className="text-[10px] font-black uppercase tracking-[0.1em] text-white/90">
              Real-Time Market Intelligence
            </span>
          </div>

          <div className="space-y-4">
            <h1 className="text-4xl font-black leading-[1.1] tracking-tight text-white md:text-6xl">
              Market <br />
              <span className="bg-gradient-to-r from-emerald-400 via-sky-300 to-indigo-300 bg-clip-text text-transparent">
                News & Updates
              </span>
            </h1>
            <p className="max-w-lg text-base font-medium leading-relaxed text-white/70 md:text-lg">
              Stay updated with the latest financial news, economic events, and
              market trends. Making informed decisions starts here.
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <Badge className="border-0 bg-white/10 px-4 py-2 text-sm text-white backdrop-blur-md">
              <Globe className="mr-2 h-4 w-4" />
              Global Coverage
            </Badge>
            <Badge className="border-0 bg-white/10 px-4 py-2 text-sm text-white backdrop-blur-md">
              <Newspaper className="mr-2 h-4 w-4" />
              Curated Insights
            </Badge>
          </div>
        </div>

        {/* Right Side: Abstract Visual */}
        <div className="relative flex items-center justify-center delay-200 duration-1000 animate-in fade-in slide-in-from-right-12 lg:justify-end">
          {/* Glowing Orbit */}
          <div className="absolute h-[300px] w-[300px] animate-pulse rounded-full bg-sky-500/10 blur-[60px]" />

          {/* Floating Stat Card */}
          <div className="relative w-full max-w-xs animate-float rounded-[1.5rem] border border-white/50 bg-white/95 p-6 shadow-[0_20px_40px_rgba(0,0,0,0.1)] backdrop-blur-3xl">
            <div className="mb-4 flex items-center gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#66A0CD] shadow-lg shadow-[#66A0CD]/20">
                <TrendingUp className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="mb-0.5 text-[10px] font-black uppercase tracking-[0.1em] text-slate-400">
                  Market Sentiment
                </p>
                <p className="text-2xl font-black text-slate-900">Bullish</p>
              </div>
            </div>
            <div className="space-y-2">
              <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
                <div className="h-full w-[75%] rounded-full bg-gradient-to-r from-emerald-400 to-[#66A0CD]" />
              </div>
              <div className="flex justify-between text-xs font-medium text-muted-foreground">
                <span>Bearish</span>
                <span>Neutral</span>
                <span className="text-[#66A0CD]">Bullish</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
